@if (hasAddress) {
<span class="address">{{ parts }}</span>
}
